<template>
  <div v-if="hasLoaded" :class="`api-sport api-sport-${siteName}`">
    <component :is="comp" :competitionId="competitionId" :seasonId="seasonId"></component>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  defineAsyncComponent,
  ref,
  nextTick
} from "vue";
import { usecommonStore } from "~src/stores/CommonStore";

// this demonstrate dynamic frontend app using a single view
export default defineComponent({
  name: "schedule",
  setup() {
    const hasLoaded = ref(false);
    const componentName = ref("Home");
    const competitionId = ref<any>("");
    const seasonId = ref<any>("");
    const siteName = ref<any>("xoilacz");
    const myComponents: any = {
      Home: defineAsyncComponent(() => import("./Home.vue")),
    };

    const comp = computed(() => {
      // compare two objects
      return myComponents[componentName.value];
    });

    const commonStore = usecommonStore();

    return {
      comp,
      componentName,
      competitionId,
      seasonId,
      siteName,
      hasLoaded,
      commonStore
    };
  },
  mounted() {
    const that = this;

    // @ts-ignore
    if (that.$win.plugin_config_schedule) {
      that.doLoad();
      return;
    }

    document.onreadystatechange = async () => {
      if (document.readyState == "complete") {
        that.doLoad();
      }
    };
  },
  methods: {
    async doLoad() {
      const that = this;

      await nextTick();

      // @ts-ignore
      let competitionId = that.$win.plugin_config_schedule.competitionId;
      if (!competitionId) {
        competitionId = that.$route.query.competitionId;
      }
      this.competitionId = competitionId ? competitionId : "";

      // @ts-ignore
      let seasonId = that.$win.plugin_config_schedule.seasonId;
      if (!seasonId) {
        seasonId = that.$route.query.seasonId;
      }
      this.seasonId = seasonId ? seasonId : "";

      this.commonStore.setSportType('football');

      // @ts-ignore
      let siteName = that.$win.plugin_config_schedule.siteName;
      if (!siteName) {
        siteName = that.$route.query.siteName || that.$route.query.sitename;
      }
      this.siteName = siteName ? siteName : "xoilacz";
      this.commonStore.setSiteName(this.siteName);

      // make sure data is loaded before ui render
      that.hasLoaded = true;
      that.$forceUpdate();
    },
  },
});
</script>

<style scoped></style>
